import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './Goals.css';
import './PickedGoals.css';

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const SelectedOneGoalConfirm = (props) => {
    const isSelected = props.itemF.selectedOne === true;

    const handleSelect = () => {
        props.selectOolaOneGoal(props.indexF, props.itemF);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleSelect();
        }
    };

    return (
        <div
            key={props.indexF}
            role="radio"
            aria-checked={isSelected}
            tabIndex={0}
            onClick={handleSelect}
            onKeyDown={handleKeyDown}
            className={`GoalArrangeOne oolaOneGoalRow${
                isSelected
                    ? ' oolaOneGoalRow--selected PickedGoalOne'
                    : ' oolaOneGoalRow--unselected NoPickedGoalOne'
            }`}
            style={{
                backgroundColor: props.Fs.color + (isSelected ? '' : '80'),
                '--oola-one-area-color': props.Fs.color,
                marginLeft: '0px',
                marginRight: '0px',
                marginTop: '10px',
            }}
        >
            <div
                className={
                    isSelected ? 'GoalNumberOne' : 'GoalNumberOneNoSelected'
                }
            >
                {props.indexF + 1}
            </div>
            <div className="oolaOneGoalRow__body">
                <div
                    className={
                        isSelected ? 'GoalSelectedOne' : 'GoalSelectedOneNoSelected'
                    }
                >
                    {props.itemF.text}
                </div>
                <div className="oolaOneGoalRow__meta">
                    <DatePicker
                        dateFormat="MMMM dd, yyyy"
                        withPortal
                        className={
                            isSelected
                                ? 'datePickerGoalOne'
                                : 'datePickerGoalOneNoSelected'
                        }
                        placeholderText="Complete by: mm/dd/yyyy"
                        minDate={new Date()}
                        selected={props.itemF.date}
                        readOnly
                        renderCustomHeader={({
                            date,
                            changeYear,
                            changeMonth,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                        }) => (
                            <div>
                                <div
                                    className="calendarHeader"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                    }}
                                >
                                    COMPLETE BY:
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        paddingTop: '10px',
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="btnCalendar"
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled}
                                    >
                                        {'<'}
                                    </button>
                                    <div className="lblMonth">
                                        {date &&
                                        !Number.isNaN(new Date(date).getTime()) ? (
                                            <>
                                                {months[new Date(date).getMonth()]}{' '}
                                                {new Date(date).getFullYear()}
                                            </>
                                        ) : (
                                            'Select a date'
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        className="btnCalendar"
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled}
                                    >
                                        {'>'}
                                    </button>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

export default SelectedOneGoalConfirm;
